import React from 'react';

const DoubtsSection = () => (
  <section className="doubts" data-testid="doubts-section">
    <div className="wrap">
      <div className="head">
        <span className="eyebrow">Before you get in touch</span>
        <h2>Fair questions.</h2>
      </div>
      <div className="qa">
        <div>
          <h3>Does it cost anything to ask?</h3>
          <p>No. Tell us the requirement or the property, and we will tell you honestly whether we can help, and how.</p>
        </div>
        <div>
          <h3>Do you work outside Edinburgh?</h3>
          <p>Edinburgh is our base, and we are building our work across the United Kingdom. Tell us where the need is.</p>
        </div>
        <div>
          <h3>Residential or commercial?</h3>
          <p>Both. We manage houses and flats, and commercial buildings too.</p>
        </div>
      </div>
    </div>
  </section>
);

export default DoubtsSection;
